export default __webpack_public_path__ + "static/sunsoaked-banner-desktop-e3b930378e1f0a620266679832e98632.webp";